<template>
    <div v-if="showVerticalMenu" id="vMenu">
        <b-link
            v-b-toggle.balance
            class="list-group-item item"
            :class="activeBalance"
        >
            SUIVI DES BILANS&nbsp;<i class="fa fa-caret-down"></i>
        </b-link>
        <b-collapse id="balance" :visible="openBalance">
            <b-list-group-item
                :href="menuRoutes['balance-global']"
                class="item sub-item"
                :active="pageName === 'balance-global'"
                @click="setPageName('balance-global')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Global
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['balance-user']"
                class="item sub-item"
                :active="pageName === 'balance-user'"
                @click="setPageName('balance-user')"
            >
                <i class="fa-fw fal fa-user-friends menu-sub-icon"></i>Par
                collaborateur
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['balance-state']"
                class="item sub-item"
                :active="pageName === 'balance-state'"
                @click="setPageName('balance-state')"
            >
                <i class="fa-fw fal fa-project-diagram menu-sub-icon"></i>Par
                état
            </b-list-group-item>
        </b-collapse>

        <b-link
            v-b-toggle.budget
            class="list-group-item item"
            :class="activeBudget"
        >
            SUIVI DES BUDGETS&nbsp;<i class="fa fa-caret-down"></i>
        </b-link>
        <b-collapse id="budget" :visible="openBudget">
            <b-list-group-item
                :href="menuRoutes['budget-forecast-company']"
                class="item sub-item"
                :active="pageName === 'budget-forecast-company'"
                @click="setPageName('budget-forecast-company')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Forecast par
                cabinet
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['budget-forecast-activity']"
                class="item sub-item"
                :active="pageName === 'budget-forecast-activity'"
                @click="setPageName('budget-forecast-activity')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Forecast par
                activité
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['budget-forecast-client']"
                class="item sub-item"
                :active="pageName === 'budget-forecast-client'"
                @click="setPageName('budget-forecast-client')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Forecast par
                client
            </b-list-group-item>
            <!--
            <b-list-group-item :href="this.menuRoutes['budget-rolling-company']"
                               class="item sub-item"
                               :active="this.pageName==='budget-rolling-company'"
                               @click="setPageName('budget-rolling-company')">
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Rolling par cabinet
            </b-list-group-item>
            <b-list-group-item :href="this.menuRoutes['budget-rolling-activity']"
                               class="item sub-item"
                               :active="this.pageName==='budget-rolling-activity'"
                               @click="setPageName('budget-rolling-activity')">
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Rolling par activité
            </b-list-group-item>
            <b-list-group-item :href="this.menuRoutes['budget-rolling-client']"
                               class="item sub-item"
                               :active="this.pageName==='budget-rolling-client'"
                               @click="setPageName('budget-rolling-client')">
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Rolling par client
            </b-list-group-item>
            -->
            <b-list-group-item
                :href="menuRoutes['budget-rolling-interactive']"
                class="item sub-item"
                :active="pageName === 'budget-rolling-interactive'"
                @click="setPageName('budget-rolling-interactive')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Rolling
                interactif
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['budget-rolling-pivot']"
                class="item sub-item"
                :active="pageName === 'budget-rolling-pivot'"
                @click="setPageName('budget-rolling-pivot')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Rolling TCD
            </b-list-group-item>
        </b-collapse>

        <b-link
            v-b-toggle.fees
            class="list-group-item item"
            :class="activeFees"
        >
            SUIVI DU CA&nbsp;<i class="fa fa-caret-down"></i>
        </b-link>
        <b-collapse id="fees" :visible="openFees">
            <b-list-group-item
                :href="menuRoutes['fees-interactive']"
                class="item sub-item"
                :active="pageName === 'fees-interactive'"
                @click="setPageName('fees-interactive')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Tableau
                interactif
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['fees-pivot']"
                class="item sub-item"
                :active="pageName === 'fees-pivot'"
                @click="setPageName('fees-pivot')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>TCD
            </b-list-group-item>
        </b-collapse>

        <b-link
            v-b-toggle.evolution
            class="list-group-item item"
            :class="activeEvolution"
        >
            EVOLUTION N vs N-1&nbsp;<i class="fa fa-caret-down"></i>
        </b-link>
        <b-collapse id="evolution" :visible="openEvolution">
            <b-list-group-item
                :href="menuRoutes['evolution-interactive']"
                class="item sub-item"
                :active="pageName === 'evolution-interactive'"
                @click="setPageName('evolution-interactive')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Tableau
                interactif
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['evolution-pivot']"
                class="item sub-item"
                :active="pageName === 'evolution-pivot'"
                @click="setPageName('evolution-pivot')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>TCD
            </b-list-group-item>
        </b-collapse>

        <b-link
            v-b-toggle.billedVsReal
            class="list-group-item item"
            :class="activeBilledVsReal"
        >
            FACTURATION vs COUT2&nbsp;<i class="fa fa-caret-down"></i>
        </b-link>
        <b-collapse id="billedVsReal" :visible="openBilledVsReal">
            <b-list-group-item
                :href="menuRoutes['billed-vs-real-interactive']"
                class="item sub-item"
                :active="pageName === 'billed-vs-real-interactive'"
                @click="setPageName('billed-vs-real-interactive')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Tableau
                interactif
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['billed-vs-real-pivot']"
                class="item sub-item"
                :active="pageName === 'billed-vs-real-pivot'"
                @click="setPageName('billed-vs-real-pivot')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>TCD
            </b-list-group-item>
        </b-collapse>

        <b-link
            v-b-toggle.importation
            class="list-group-item item"
            :class="activeImportation"
        >
            IMPORTATION&nbsp;<i class="fa fa-caret-down"></i>
        </b-link>
        <b-collapse id="importation" :visible="openImportation">
            <b-list-group-item
                :href="menuRoutes['import-budget']"
                class="item sub-item"
                :active="pageName === 'import-budget'"
                @click="setPageName('import-budget')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Budget
            </b-list-group-item>
            <b-list-group-item
                :href="menuRoutes['import-fees']"
                class="item sub-item"
                :active="pageName === 'import-fees'"
                @click="setPageName('import-fees')"
            >
                <i class="fa-fw fal fa-table menu-sub-icon"></i>Facturation
            </b-list-group-item>
        </b-collapse>
    </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'DashboardVerticalMenu',

    props: {
        page: '',
    },

    data() {
        return {
            openBalance: false,
            activeBalance: '',
            openBudget: false,
            activeBudget: '',
            openFees: false,
            activeFees: '',
            openEvolution: false,
            activeEvolution: '',
            openBilledVsReal: false,
            activeBilledVsReal: '',
            openImportation: false,
            activeImportation: '',
        }
    },

    async created() {
        await this.$store.dispatch('dashboardVM/getRoutes')
        this.$store.commit('dashboardVM/SHOW_VERTICAL_MENU')
        this.handleBalanceMenu()
        this.handleBudgetMenu()
        this.handleFeesMenu()
        this.handleEvolutionMenu()
        this.handleBilledVsRealMenu()
        this.handleImportationMenu()
    },

    methods: {
        async setPageName(pageName) {
            await this.$store.dispatch('reportingVM/getFilters')
            this.$store.commit('browsing/SET_PAGE_NAME', pageName)
        },
        handleBalanceMenu() {
            this.openBalance = [
                'balance-global',
                'balance-user',
                'balance-state',
            ].includes(this.page)
            this.activeBalance = this.openBalance ? 'active' : ''
        },
        handleBudgetMenu() {
            this.openBudget = [
                'budget-forecast-company',
                'budget-forecast-client',
                'budget-forecast-activity',
                'budget-rolling-company',
                'budget-rolling-activity',
                'budget-rolling-client',
                'budget-rolling-interactive',
                'budget-rolling-pivot',
            ].includes(this.page)
            this.activeBudget = this.openBudget ? 'active' : ''
        },
        handleFeesMenu() {
            this.openFees = ['fees-interactive', 'fees-pivot'].includes(
                this.page
            )
            this.activeFees = this.openFees ? 'active' : ''
        },
        handleEvolutionMenu() {
            this.openEvolution = [
                'evolution-interactive',
                'evolution-pivot',
            ].includes(this.page)
            this.activeEvolution = this.openEvolution ? 'active' : ''
        },
        handleBilledVsRealMenu() {
            this.openBilledVsReal = [
                'billed-vs-real-interactive',
                'billed-vs-real-pivot',
            ].includes(this.page)
            this.activeBilledVsReal = this.openBilledVsReal ? 'active' : ''
        },
        handleImportationMenu() {
            this.openImportation = ['import-budget', 'import-fees'].includes(
                this.page
            )
            this.activeImportation = this.openImportation ? 'active' : ''
        },
    },

    computed: {
        ...mapState({
            pageName: (state) => state.browsing.pageName,
            showVerticalMenu: (state) => state.dashboardVM.showVerticalMenu,
            menuRoutes: (state) => state.dashboardVM.menuRoutes,
        }),
    },
}
</script>

<style scoped></style>
